export default {
  header: 'Trebuie să verificăm numărul tău de telefon',
  remember_device: {
    label: 'Ține minte acest dispozitiv {{days}} zile',
  },
  buttons: {
    confirm: 'Confirmă',
  },
  toasts: {
    invalid_code: 'Cod invalid. Încearcă din nou.',
  },
};
